import axios from 'axios';
import { useQuery } from './useQuery';
import { Concept } from '../types/concept.types';
import { Cycle } from '../types/cycle.types';
import { Participant } from '../types/participant.types';
import { CacheId } from './useCache';

type GetDictionaryProps = {
  dummy?: boolean;
  course?: Concept;
  cycle?: Cycle;
  participant?: Participant;
};

function getDictionary({
  dummy,
  course,
  cycle,
  participant,
}: GetDictionaryProps = {}) {
  const params = {
    dummy,
    courseId: course?._id,
    cycleId: cycle?._id,
    participantId: participant?.id,
  };
  const cacheId: CacheId = ['dictionary', params];
  const { result } = useQuery(cacheId, () =>
    axios
      .get('/api/data-content-items/', { params })
      .then((result) => result.data)
  );

  return result;
}

export { getDictionary };
